<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Название</label>
            <crm-input-text
              [(value)]="erp1cOperationType.name"
              [isError]="$any(errors?.name)"></crm-input-text>
            <small
              *ngIf="errors?.name"
              class="p-error">
              {{ errors.name | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Синоним</label>
            <crm-input-text
              [(value)]="erp1cOperationType.alias"
              [isError]="$any(errors?.alias)"></crm-input-text>
            <small
              *ngIf="errors?.alias"
              class="p-error">
              {{ errors.alias | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип объекта в 1С</label>
            <crm-single-select
              [options]="objectTypes"
              [(selectedItem)]="erp1cOperationType.objectType"
              optionValue="name"
              [isTemplateCombined]="true"
              [filter]="false"
              [isError]="!!errors?.objectType"
              appendTo="body">
              <ng-template
                #itemTemplate
                let-type="item">
                {{ type.value | erp1cObjectTypeName }}
              </ng-template>
            </crm-single-select>
            <small
              *ngIf="errors?.objectType"
              class="p-error">
              {{ errors.objectType | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Группа</label>
            <crm-operation-type-single-select
              [(selectedOperationType)]="erp1cOperationType.operationType"
              [isError]="$any(errors?.operationType)"
              [showClear]="false"
              appendTo="body"></crm-operation-type-single-select>
            <small
              *ngIf="errors?.operationType"
              class="p-error"
              >{{ errors.operationType | join }}</small
            >
          </div>

          <div class="field">
            <label class="font-medium required-field">База 1С</label>
            <div class="flex gap-1">
              <crm-database-single-select
                [databases]="databases"
                [(selectedDatabase)]="erp1cOperationType.connection"
                [showClear]="false"
                styleClass="w-full"
                class="w-full"
                appendTo="body"
                [class]="errors?.connection ? 'ng-invalid ng-dirty' : ''">
              </crm-database-single-select>
              <crm-button
                *ngIf="canWriteCompanyErp1C"
                icon="pi pi-plus"
                styleClass="p-button-info"
                pTooltip="Добавить новую Базу 1С"
                tooltipPosition="top"
                (onClick)="showDialogCreate1C()">
              </crm-button>
            </div>
            <small
              *ngIf="errors?.connection"
              class="p-error">
              {{ errors.connection | join }}
            </small>
          </div>

          <div
            *ngIf="erp1cOperationType['deleted']"
            class="text-right">
            <p-tag
              severity="danger"
              value="Удален"
              styleClass="mt-2"></p-tag>
          </div>
        </div>
      </p-card>

      <div
        class="mt-3"
        *ngIf="formStoreService.getState.forms[this.index]?.isEdit">
        <crm-directory-common-history
          [entityName]="DirectoryCommonHistoryTypeEnum.OPERATION_TYPE_ERP_1C"
          [entityId]="formStoreService.getState.forms[this.index]?.entityId"
          [apiService]="erp1cOperationTypeService">
        </crm-directory-common-history>
      </div>
    </div>
  </div>

  <div
    *ngIf="(form$ | async)?.canWrite"
    class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <crm-button
        [label]="saveButtonLabel"
        styleClass="p-button-success mr-2"
        (onClick)="saveErp1cOperationType()"></crm-button>
      <div class="flex align-items-center gap-2">
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && !erp1cOperationType['deleted']"
          label="Удалить"
          styleClass="p-button-danger p-button-text"
          (onClick)="deleteErp1cOperationType()"></crm-button>
        <crm-button
          *ngIf="(form$ | async)?.isShowDelete && erp1cOperationType['deleted']"
          icon="pi pi-undo"
          label="Восстановить"
          styleClass="p-button-info p-button-text"
          (onClick)="restoreErp1cOperationType()"></crm-button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
